// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper-menu":"wrapper-menu","wrapper-btn":"wrapper-btn","wrapper-icon":"wrapper-icon","sip-menu":"sip-menu"};